import modalReducer from 'common/modal/ducks';
import ModalContainer from 'common/modal/containers';
import ModalTrigger from 'common/modal/containers/trigger';

export { modalReducer, ModalTrigger };
export default ModalContainer;
